export const SET_IS_IN_IFRAME = 'SET_IS_IN_IFRAME';
export const SET_CHART_LIST = 'SET_CHART_LIST';
export const SET_COM_REFS = 'SET_COM_REFS';
export const SET_CURR_IFRAME_URL = 'SET_CURR_IFRAME_URL';
export const SET_ROUTES = 'SET_ROUTES';
